import React, { useState, useEffect } from 'react';
import { Marker, GoogleMap, DirectionsRenderer } from '@react-google-maps/api';

type GoogleMapWithDirectionsProps = {
  origin: string;
  destination: string;
};

const GoogleMapWithDirections = ({
  origin,
  destination,
}: GoogleMapWithDirectionsProps) => {
  const [response, setResponse] = useState<google.maps.DirectionsResult | null>(
    null
  );

  useEffect(() => {
    const directionsCallback = (result: any) => {
      if (result !== null && result.status === 'OK') {
        setResponse(result);
      }
    };

    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      directionsCallback
    );
  }, [origin, destination]);

  const destinationIcon = {
    url: '/img/destination.svg',
    scaledSize: new window.google.maps.Size(30, 30),
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(15, 25),
  };

  const originIcon = {
    url: '/img/origin.svg',
    scaledSize: new window.google.maps.Size(15, 15),
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(10, 10),
  };

  return (
    <GoogleMap
      zoom={8}
      mapContainerStyle={{ height: '400px', width: '100%' }}
      options={{
        zoomControl: true,
        streetViewControl: false,
      }}
    >
      {response && (
        <>
          <DirectionsRenderer
            options={{
              directions: response,
              polylineOptions: {
                strokeColor: '#56CA00',
                strokeWeight: 6,
              },
              suppressMarkers: true,
            }}
          />
          <Marker
            position={{
              lat: response?.routes[0].legs[0].start_location.lat(),
              lng: response?.routes[0].legs[0].start_location.lng(),
            }}
            icon={originIcon}
          />
          <Marker
            position={{
              lat: response?.routes[0].legs[0].end_location.lat(),
              lng: response?.routes[0].legs[0].end_location.lng(),
            }}
            icon={destinationIcon}
          />
        </>
      )}
    </GoogleMap>
  );
};

export default GoogleMapWithDirections;
